import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog/dialog";
import { useNavigate } from "react-router-dom";
import { Note } from "./note";
import { MessageSquareText } from "lucide-react";
import { ROUTES } from "@/routes";
import { useCallback } from "react";

export function NoteDialog() {
  const navigate = useNavigate();

  const handleOpenChange = useCallback(
    (open: boolean) =>
      void (!open && setTimeout(() => navigate(ROUTES.HOME), 500)),
    [navigate]
  );

  return (
    <Dialog defaultOpen onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-4xl max-h-[80%]">
        <DialogHeader>
          <DialogTitle>
            <div className="flex gap-2 items-center">
              <MessageSquareText />
              <p>Sap Note</p>
            </div>
          </DialogTitle>
        </DialogHeader>
        <DialogBody className="overflow-auto">
          <Note />
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
